import React from 'react'
import './style.scss'


import DsnGrid from "../DsnGrid";
import type { DsnGridProps } from "../DsnGrid";
import { dsnCN } from "../../hooks/helper";
import LazyImg from "../LazyImg";

const ServicesDetails = [
    {
        icon: 'assets/img/services/bard.png',
        title: "Music",
        description: "Whispers of distant worlds guiding you through hidden realms",
    },
    {
        icon: 'assets/img/services/ice.png',
        title: "Podcast",
        description: "Meditative storytelling for wandering beyond the visible",
    },
    {
        icon: 'assets/img/services/stick.png',
        title: "Website",
        description: "I open the gate through which my music and stories enter this world",
    },
]

const ServiceOne = ({ className, ...restProps }: DsnGridProps) => {
    return (
        <DsnGrid className={dsnCN('dsn-services service-one', className)} {...restProps}>
            {ServicesDetails.map(
                (item, index) =>
                    <div className='service-item' key={index}>
                        <span className='icon mb-20'>
                            <LazyImg src={item.icon} alt={item.title} />
                        </span>
                        <h4 className='title-block mb-20'>{item.title}</h4>
                        <p className='mt-15 dsn-auto'>{item.description}</p>
                    </div>
            )}

        </DsnGrid>
    );
};


export default ServiceOne